import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';

export function matchValueValidator(compareControl: FormControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const valuesMatch = control.value === compareControl.value;
        return valuesMatch ? null : { mismatch: { value: control.value } };
    };
}
